import * as Yup from 'yup';

export interface PrescribingProtocol {
  condition_id: string;
  url: string;
}

export interface PublicProfileFormData {
  title: string;
  bio: string;
  image_url: string;
}

export interface PrescriberFormData {
  forename: string;
  surname: string;
  email: string;
  roles: string[];
  nmcNumber?: string;
  gphcNumber?: string;
  address?: string;
  postcode?: string;
  telephone?: string;
  clinic_name?: string;
  registration_body?: string;
  prescribing_protocols: PrescribingProtocol[];
  public_profile: PublicProfileFormData;
  // Per clinic: whether this clinic's pages show the prescriber.
  show_on_clinic: boolean;
}

export const emptyProtocol: PrescribingProtocol = {
  condition_id: '',
  url: ''
};

export const initialFormData: PrescriberFormData = {
  forename: '',
  surname: '',
  email: '',
  roles: ['prescriber'],
  nmcNumber: '',
  gphcNumber: '',
  address: '',
  postcode: '',
  telephone: '',
  clinic_name: '',
  registration_body: '',
  prescribing_protocols: [],
  public_profile: { title: '', bio: '', image_url: '' },
  show_on_clinic: false
};

export const prescriberSchema = Yup.object().shape({
  forename: Yup.string().required('First name is required'),
  surname: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  roles: Yup.array().of(Yup.string()).min(1, 'At least one role is required'),
  nmcNumber: Yup.string().optional(),
  gphcNumber: Yup.string().optional(),
  address: Yup.string().optional(),
  postcode: Yup.string().optional(),
  telephone: Yup.string().optional(),
  clinic_name: Yup.string().optional(),
  registration_body: Yup.string().optional(),
  prescribing_protocols: Yup.array().of(
    Yup.object().shape({
      condition_id: Yup.string().required('Condition is required'),
      url: Yup.string()
        .url('Must be a valid URL')
        .matches(/^https:\/\//, 'Must start with https://')
        .required('Protocol URL is required')
    })
  ),
  public_profile: Yup.object().shape({
    title: Yup.string().optional(),
    bio: Yup.string().optional(),
    image_url: Yup.string().optional()
  }),
  show_on_clinic: Yup.boolean()
});
